"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POINTS_AWARD = void 0;
exports.calculateRank = calculateRank;
exports.POINTS_AWARD = {
    PRAYER_COMPLETED: 25,
    HUB_CREATED: 30,
};
function calculateRank(points) {
    if (points >= 2500)
        return 'shield-wall';
    if (points >= 800)
        return 'lighthouse';
    if (points >= 200)
        return 'torch';
    return 'spark';
}
//# sourceMappingURL=gamification.js.map